//Output:Like "1 Jan 2023"
export function getDateValue(inputDateStr) {
  const date = new Date(inputDateStr);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  // const month = months[date.getMonth()];
  const month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure two digits for minutes

  // return `${day} ${month} ${year}, ${hours}:${minutes}`;
  return `${day} /${month}/ ${year}`;
}

//Output:Like "1/1/2023 - 12:34 PM - 03:45 PM"
export function getDateTime(startISOString, endISOString) {
  const startDate = new Date(startISOString);
  const endDate = new Date(endISOString);

  const options = {
    // year: 'numeric',
    // month: '2-digit',
    // day: '2-digit',
    hour: "2-digit",
    minute: "2-digit",
  };

  const formattedStartDate = startDate
    .toLocaleDateString("en-GB", options)
    .replace(/\//g, "/");
  const formattedEndTime = endDate.toLocaleTimeString("en-GB", options);

  return `${formattedStartDate} ${formattedEndTime != "Invalid Date" ? `- ${formattedEndTime}` : ""
    }`;
}

//Output:Like "1 Jan 2023, 12:34"

export function getDateValueWithSingleTime(inputDateStr) {
  const date = new Date(inputDateStr);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure two digits for minutes

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
  // return `${day} ${month} ${year}`;
}


export function getDateTimeValue(inputDateStr) {
  const date = new Date(inputDateStr);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure two digits for minutes

  return `${day} /${month}/ ${year}, ${hours}:${minutes}`;
}